import React from 'react';
import { NavLink, Link } from 'react-router-dom';

const navItems = [
  { to: '/admin', end: true, label: 'Overview', icon: '📊' },
  { to: '/admin/reports', label: 'Reports', icon: '📋' },
  { to: '/admin/feedback', label: 'Feedback', icon: '💬' },
  { to: '/admin/costs', label: 'AI Costs', icon: '💰' },
  { to: '/admin/approvals', label: 'Approvals', icon: '✅', badgeKey: 'approvals' },
  { to: '/admin/agencies', label: 'Agencies', icon: '🏢' },
  { to: '/admin/audits', label: 'All Audits', icon: '🔍' },
  { to: '/admin/settings', label: 'Audit Settings', icon: '⚙️' },
];

export default function AdminLayout({ children, pendingCount = 0 }) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-teal-50/30 to-slate-100">
      <header className="bg-gradient-to-r from-slate-900 via-teal-900 to-slate-800 text-white shadow-lg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <img src="/chart-auditer-ai-logo.svg" alt="ChartAudit AI" className="h-10 w-auto brightness-0 invert" />
            <div>
              <h1 className="text-lg font-bold tracking-tight">Platform Admin</h1>
              <p className="text-teal-200/80 text-xs">ChartAudit AI Control Center</p>
            </div>
          </div>
          <Link to="/" className="text-sm text-teal-100 hover:text-white bg-white/10 hover:bg-white/20 px-3 py-1.5 rounded-lg transition">
            ← Back to App
          </Link>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 flex flex-col lg:flex-row gap-8">
        <aside className="lg:w-56 shrink-0">
          <nav className="glass-card rounded-2xl border border-teal-100/50 shadow-sm p-2 space-y-1 sticky top-4">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition ${
                    isActive
                      ? 'bg-teal-600 text-white shadow-md'
                      : 'text-gray-600 hover:bg-teal-50 hover:text-teal-800'
                  }`
                }
              >
                <span className="text-base">{item.icon}</span>
                <span className="flex-1">{item.label}</span>
                {item.badgeKey === 'approvals' && pendingCount > 0 && (
                  <span className="bg-yellow-400 text-yellow-900 text-xs font-bold px-2 py-0.5 rounded-full">
                    {pendingCount}
                  </span>
                )}
              </NavLink>
            ))}
          </nav>
        </aside>

        <main className="flex-1 min-w-0">{children}</main>
      </div>
    </div>
  );
}
